import React from 'react';
import '../../styles/onboardingFlow/slides/slide2.scss';
import sparkleIcon from '../../assets/onboarding/slides/slide2/Sparkle.svg';
import bellIcon from '../../assets/onboarding/slides/slide2/BellRinging.svg';
import window1 from '../../assets/onboarding/slides/slide2/window1.svg';
import window2 from '../../assets/onboarding/slides/slide2/window2.svg';
import window3 from '../../assets/onboarding/slides/slide2/window3.svg';

const Slide2 = () => {
  return (
    <div className='slide2'>
      <div className='slide2__content'>
        {/* Sparkle Icon at top left */}
        <div className='slide2__sparkle'>
          <img src={sparkleIcon} alt='Sparkle' />
        </div>

        {/* Report Windows */}
        <div className='slide2__windows'>
          <div className='slide2__window slide2__window--1'>
            <img src={window1} alt='Report Window 1' />
          </div>
          <div className='slide2__window slide2__window--2'>
            <img src={window2} alt='Report Window 2' />
          </div>
          <div className='slide2__window slide2__window--3'>
            <img src={window3} alt='Report Window 3' />
          </div>
        </div>

        {/* Main Content */}
        <div className='slide2__main'>
          {/* Title with Icon at the end */}
          <div className='slide2__title'>
            <h1>
              Automated reporting{' '}
              <img src={bellIcon} alt='Bell' className='slide2__title-icon' />
            </h1>
          </div>

          {/* Subtitle */}
          <h2 className='slide2__subtitle'>Smart, Unified, Instant</h2>

          {/* Description */}
          <p className='slide2__description'>
            Connect once and let TARA handle the rest. Get clear, automated
            reports across every channel - always up-to-date, always ready to
            share
          </p>

          {/* Progress Bars */}
          <div className='slide2__progress'>
            <div className='slide2__progress-dot'></div>
            <div className='slide2__progress-dot slide2__progress-dot--active'></div>
            <div className='slide2__progress-dot'></div>
            <div className='slide2__progress-dot'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide2;
